// extracted by mini-css-extract-plugin
export var navbar = "navbar-module--navbar--2qBYC";
export var navbarIcon = "navbar-module--navbarIcon--2pwlY";
export var navbarEndBtns = "navbar-module--navbarEndBtns--3SNRM";
export var navbarButton = "navbar-module--navbarButton--1A0mA";